import React from "react";
import { GroupHeadingView } from "./view";
import { styles } from "./styles";

export class GroupHeading extends React.Component {
  render() {
    return <GroupHeadingView {...this.props} styles={styles} />;
  }
}
